(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.kan-fp').forEach(function(sec){
      var track = sec.querySelector('.kan-fp__track');
      if(!track) return;
      sec.querySelectorAll('.kan-fp__arrow').forEach(function(btn){
        btn.addEventListener('click', function(){
          var dir = parseInt(btn.getAttribute('data-dir'), 10);
          track.scrollBy({ left: dir * Math.max(280, track.clientWidth * 0.6), behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.kan-hero').forEach(function(sec){
      var track = sec.querySelector('.kan-hero__track'), dotsWrap = sec.querySelector('.kan-hero__dots');
      if(!track || !dotsWrap) return;
      var slides = track.children, n = slides.length;
      if(n === 0) return;
      var dh = '';
      for(var i=0;i<n;i++){ dh += '<button class="kan-hero__dot' + (i===0?' is-on':'') + '" data-i="'+i+'" aria-label="Slide '+(i+1)+'"></button>'; }
      dotsWrap.innerHTML = dh;
      var dots = dotsWrap.children;
      function setDot(i){ for(var k=0;k<dots.length;k++){ dots[k].classList.toggle('is-on', k===i); } }
      function index(){
        var tr = track.getBoundingClientRect(), c = tr.left + tr.width/2, best = 0, bd = 1e9;
        for(var k=0;k<n;k++){ var r = slides[k].getBoundingClientRect(); var d = Math.abs((r.left + r.width/2) - c); if(d < bd){ bd = d; best = k; } }
        return best;
      }
      function go(i){
        i = ((i % n) + n) % n; var el = slides[i]; if(!el) return;
        var tr = track.getBoundingClientRect(), r = el.getBoundingClientRect();
        var to = track.scrollLeft + (r.left - tr.left) - (tr.width - r.width)/2;
        if(track.scrollTo){ track.scrollTo({left: to, behavior: 'smooth'}); } else { track.scrollLeft = to; }
        setDot(i);
      }
      dotsWrap.addEventListener('click', function(e){ var b = e.target.closest('.kan-hero__dot'); if(!b) return; go(parseInt(b.getAttribute('data-i'), 10)); });
      var t;
      track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(function(){ setDot(index()); }, 90); }, {passive:true});
      var ms = parseInt(sec.getAttribute('data-autoplay'), 10) || 0;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(ms > 0 && n > 1 && !reduce){ setInterval(function(){ go(index() + 1); }, ms); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kits-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.kan-kits').forEach(function(sec){
      var track = sec.querySelector('.kan-kits__track'); if(!track) return;
      sec.querySelectorAll('.kan-kits__arrow').forEach(function(btn){
        btn.addEventListener('click', function(){
          var dir = parseInt(btn.getAttribute('data-dir'), 10);
          track.scrollBy({ left: dir * Math.max(280, track.clientWidth * 0.6), behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-custom"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.kan-rev').forEach(function(root){
      var track = root.querySelector('.kan-rev__track');
      var animate = root.getAttribute('data-animate') === 'true';
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isEditor = window.Shopify && window.Shopify.designMode;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var autoplaySpeed = parseFloat(root.getAttribute('data-autoplay-speed')) || 4;
      // arrows
      root.querySelectorAll('.kan-rev__arrow').forEach(function(btn){
        btn.addEventListener('click', function(){
          if(!track) return;
          var dir = parseInt(btn.getAttribute('data-dir'), 10);
          var card = track.querySelector('.kan-rev__card');
          var step = card ? card.getBoundingClientRect().width + 18 : track.clientWidth * 0.6;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
      // reveal helpers
      function revealEl(el){
        /* FIX: los elementos individuales (título, resumen, CTA) traen data-i
           para escalonar su aparición — antes nunca se leía, así que siempre
           usaban el delay 0 por default y aparecían los 3 al mismo tiempo. */
        var di = el.getAttribute('data-i');
        if(di !== null){ el.style.setProperty('--i', di); }
        el.classList.add('is-visible');
      }
      function staggerGroup(group){
        var items = group.querySelectorAll(':scope > .kan-rev-stagger');
        items.forEach(function(item, i){
          item.style.setProperty('--i', i);
          revealEl(item);
        });
      }
      function revealAllNow(){
        root.querySelectorAll('.kan-rev-anim').forEach(revealEl);
        root.querySelectorAll('.kan-rev-anim-group').forEach(staggerGroup);
      }
      if(!animate || reduced || !('IntersectionObserver' in window) || isEditor){
        revealAllNow();
      } else {
        var singleObserver = new IntersectionObserver(function(entries, obs){
          entries.forEach(function(entry){
            if(entry.isIntersecting){ revealEl(entry.target); obs.unobserve(entry.target); }
          });
        }, { threshold: 0.2, rootMargin: '0px 0px -30px 0px' });
        var groupObserver = new IntersectionObserver(function(entries, obs){
          entries.forEach(function(entry){
            if(entry.isIntersecting){ staggerGroup(entry.target); obs.unobserve(entry.target); }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
        root.querySelectorAll('.kan-rev-anim').forEach(function(el){
          if(el.closest('.kan-rev-anim-group')) return;
          singleObserver.observe(el);
        });
        root.querySelectorAll('.kan-rev-anim-group').forEach(function(el){ groupObserver.observe(el); });
      }
      // autoplay
      if(autoplay && track && !reduced){
        var timer = null;
        function startAuto(){
          stopAuto();
          timer = setInterval(function(){
            var card = track.querySelector('.kan-rev__card');
            var style = getComputedStyle(track);
            var gapVal = parseFloat(style.columnGap || style.gap || 18) || 18;
            var step = card ? card.getBoundingClientRect().width + gapVal : 300;
            var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
            if(atEnd){ track.scrollTo({ left: 0, behavior: 'smooth' }); }
            else { track.scrollBy({ left: step, behavior: 'smooth' }); }
          }, autoplaySpeed * 1000);
        }
        function stopAuto(){ if(timer) clearInterval(timer); }
        startAuto();
        track.addEventListener('mouseenter', stopAuto);
        track.addEventListener('mouseleave', startAuto);
        track.addEventListener('touchstart', stopAuto, { passive: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
